export default "__VITE_ASSET__Cq3YDHQ9__"